import React, { useState, useEffect } from 'react'
import { Button, Modal, message, Tabs, Steps, Space, Select, Spin, Alert } from 'antd'
import { LoadingOutlined, SmileOutlined, SolutionOutlined, UserOutlined } from '@ant-design/icons'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Image from 'next/image'
import Script from 'next/script'
import { useRouter } from 'next/router'

import dynamic from 'next/dynamic'

export default BindIllustrate => {
  const [isModalOpen, setIsModalOpen] = useState(true)

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const router = useRouter()

  return (
    <>
      <Modal className='illustrate' open={isModalOpen} onCancel={handleCancel} footer={[]} width={500} closable={false}>
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: '20px', textAlign: 'center' }}>
            You have completed the device connection, please wait patiently for the data to be sent back.
          </p>
        </div>
      </Modal>
    </>
  )
}
